import { UpgradeResourcePackage } from "by/gamefactory/cityversetycoon/scenes/popups/mybuildings/resources/UpgradeResourcePackage";
import { Texture } from "pixi.js";

export class CubeTexturePack {
    public readonly randomCubes: Texture[];

    public constructor(upgradeResources: UpgradeResourcePackage) {
        this.randomCubes = this.randomCubeTextures(upgradeResources);
    }

    private randomCubeTextures(upgradeResources: UpgradeResourcePackage): Texture[] {
        return [
            upgradeResources.assets_views_upgrade_particles_cube_1_png,
            upgradeResources.assets_views_upgrade_particles_cube_2_png,
            upgradeResources.assets_views_upgrade_particles_cube_3_png,
            upgradeResources.assets_views_upgrade_particles_cube_4_png,
            upgradeResources.assets_views_upgrade_particles_cube_5_png,
            upgradeResources.assets_views_upgrade_particles_cube_6_png,
            upgradeResources.assets_views_upgrade_particles_cube_7_png,
            upgradeResources.assets_views_upgrade_particles_cube_8_png,
            upgradeResources.assets_views_upgrade_particles_cube_9_png,
            upgradeResources.assets_views_upgrade_particles_cube_10_png
        ];
    }
}